const ScoreBar = ({ label, percent, sub, color = "#4338CA" }) => (
  <div className="mb-4" data-testid={`score-bar-${label.replace(/\s+/g, '-').toLowerCase()}`}>
    <div className="flex items-baseline justify-between mb-1">
      <span className="font-body text-sm font-medium text-slate-700">{label}</span>
      <span className="font-heading font-bold text-sm text-slate-900">{percent}%</span>
    </div>
    <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden">
      <div className="h-full rounded-full transition-[width] duration-700"
           style={{ width: `${percent}%`, background: color }} />
    </div>
    {sub && <p className="font-body text-xs text-slate-400 mt-1">{sub}</p>}
  </div>
);

export default ScoreBar;
